import Vue from "vue";
import Vuex from "vuex";
import { createStore } from "vuex-extensions";
import affiliates from "./affiliates/index";
import alert from "./alert/index";
import alterRedirect from "./alterRedirect/index";
import banner from "./banner/index";
import bannerLatestUpdate from "./bannerLatestUpdate/index";
import isLoading from "./loading/index";
import notification from "./notification/index";
import privateFile from "./privateFile/index";
import forgotPwd from "./user/forgotPwd/index";
import guide from "./user/guide/index";
import login from "./user/login/index";
import createMerchant from "./user/merchant/createMerchant/index";
import register from "./user/register/index";
import userTour from "./user/userTour/index";
import verification from "./user/verification/index";
import videoFeedback from "./user/videoFeedback/index";

Vue.use(Vuex);

const store = createStore(Vuex.Store, {
  modules: {
    login,
    register,
    forgotPwd,
    createMerchant,
    alert,
    isLoading,
    affiliates,
    banner,
    userTour,
    guide,
    notification,
    videoFeedback,
    bannerLatestUpdate,
    verification,
    privateFile,
    alterRedirect,
  },
});

export default store;
